var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-printer"},on:{"click":_vm.printPage}}),_c('div',{ref:"pdfContent",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }